import { i18n } from '../services/i18n'

export const getLabel = (ns, key) => {
  return i18n.t(`${ns}:${key}`)
}
